import { render } from "./GeneralLayout.vue?vue&type=template&id=4ea7e597&scoped=true"
import script from "./GeneralLayout.vue?vue&type=script&lang=js"
export * from "./GeneralLayout.vue?vue&type=script&lang=js"

import "./GeneralLayout.vue?vue&type=style&index=0&id=4ea7e597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea7e597"]])

export default __exports__